<template>
  <div class="content-library">
    <el-card shadow="never">
      <template #header>
        <div class="card-header">
          <span>📥 已下载待编辑（素材库）</span>
          <div>
            <el-button size="small" type="warning" plain @click="$router.push('/benchmark')">🎯 去对标下载</el-button>
            <el-button size="small" type="warning" @click="$router.push('/quick')">⚡ 快捷上传</el-button>
        <el-upload :auto-upload="false" :limit="1" :on-change="onLibUpload" accept="video/*,image/*,audio/*" :show-file-list="false" style="display:inline-block; margin-left:8px">
          <el-button size="small" type="primary">📥 上传素材</el-button>
        </el-upload>
            <el-button size="small" @click="load">刷新</el-button>
          </div>
        </div>
      </template>

      <el-alert
        type="info" :closable="false" show-icon
        title="流程：对标下载 / 本地上传 → 素材库（待编辑）→ 编辑（入库/剪辑/洗稿）→ 上传（选平台：抖音全自动发布，快手/小红书即将上线）"
        style="margin-bottom:12px"
      />

      <el-table v-if="!isMobile" :data="rows" v-loading="loading" stripe>
        <el-table-column label="封面" width="64">
          <template #default="{row}">
            <el-image v-if="row.cover_url" :src="row.cover_url" fit="cover" style="width:52px;height:68px;border-radius:4px">
              <template #error><div class="no-cover">🎬</div></template>
            </el-image>
            <div v-else class="no-cover">🎬</div>
          </template>
        </el-table-column>
        <el-table-column label="标题" min-width="170" show-overflow-tooltip>
          <template #default="{row}">
            <span class="lib-title-cell" :title="row.file_path || row.title">{{ row.title || '（无标题）' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="来源" width="120">
          <template #default="{row}">
            <el-tag size="small" :type="row.type === 'benchmark' ? 'warning' : 'info'">{{ row.source_account }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="点赞" width="70">
          <template #default="{row}">{{ row.digg_count || '-' }}</template>
        </el-table-column>
        <el-table-column label="大小" width="80">
          <template #default="{row}">{{ fmtSize(row.size) }}</template>
        </el-table-column>
        <el-table-column label="编辑状态" width="150">
          <template #default="{row}">
            <el-tag v-if="row.pq_status === 'done'" size="small" type="success">✅ 已发布</el-tag>
            <el-tag v-else-if="row.pq_status === 'publishing'" size="small" type="primary">🚀 发布中</el-tag>
            <el-tag v-else-if="row.edited_file_path || row.rewrite_versions.length" size="small" type="success">🎬✍️ 已编辑</el-tag>
            <el-tag v-else-if="row.pq_id" size="small" type="warning">⚙️ 加工中</el-tag>
            <el-tag v-else size="small" type="info">📋 待编辑</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="加工日志" width="100">
          <template #default="{row}">
            <el-button v-if="row.auto_log" size="small" link type="primary" @click="showLog(row)">📜 日志</el-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="470">
          <template #default="{row}">
            <div class="row-ops">
              <el-button v-if="row.url" size="small" type="info" plain @click="preview(row)">▶ 预览</el-button>
              <el-button size="small" type="primary" :loading="editingId === row.id && editMode === 'full'" @click="edit(row,'full')">📦 入库</el-button>
              <el-button size="small" :loading="editingId === row.id && editMode === 'clip'" @click="edit(row,'clip')">🎬 剪辑</el-button>
              <el-button size="small" type="info" plain :loading="eraseId === row.id" @click="openErase(row)">🧹 去字幕</el-button>
              <el-button size="small" :loading="editingId === row.id && editMode === 'rewrite'" @click="edit(row,'rewrite')">✍️ 洗稿</el-button>
              <el-button size="small" type="warning" :loading="analyzingId === row.id" @click="analyze(row)">🎬 拆解</el-button>
              <el-button size="small" type="success" :disabled="row.pq_status === 'publishing'" @click="openUpload(row)">🚀 上传</el-button>
              <el-button v-if="row.replica_report" size="small" link type="primary" @click="showReport(row)">📋报告</el-button>
              <el-button size="small" type="danger" plain @click="delItem(row)">🗑 删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 手机端：卡片列表（避免表格挤压按钮/文字被遮） -->
      <div v-else class="lib-cards">
        <div v-for="row in rows" :key="row.id" class="lib-card">
          <div class="lib-top">
            <el-image v-if="row.cover_url" :src="row.cover_url" fit="cover" class="lib-cover">
              <template #error><div class="no-cover-big">🎬</div></template>
            </el-image>
            <div v-else class="no-cover-big">🎬</div>
            <div class="lib-info">
              <div class="lib-title">{{ row.title || '（无标题）' }}</div>
              <div class="lib-meta">
                <el-tag size="small" :type="row.type === 'benchmark' ? 'warning' : 'info'">{{ row.source_account }}</el-tag>
                <span>{{ fmtSize(row.size) }}</span>
                <span v-if="row.digg_count">👍 {{ row.digg_count }}</span>
              </div>
              <div class="lib-status">
                <el-tag v-if="row.pq_status === 'done'" size="small" type="success">✅ 已发布</el-tag>
                <el-tag v-else-if="row.pq_status === 'publishing'" size="small" type="primary">🚀 发布中</el-tag>
                <el-tag v-else-if="row.edited_file_path || row.rewrite_versions.length" size="small" type="success">🎬✍️ 已编辑</el-tag>
                <el-tag v-else-if="row.pq_id" size="small" type="warning">⚙️ 加工中</el-tag>
                <el-tag v-else size="small" type="info">📋 待编辑</el-tag>
                <el-button v-if="row.auto_log" size="small" link type="primary" @click="showLog(row)">📜 日志</el-button>
              </div>
            </div>
          </div>
          <div class="lib-btns">
            <el-button v-if="row.url" size="small" type="info" plain @click="preview(row)">▶ 预览</el-button>
            <el-button size="small" type="primary" :loading="editingId === row.id && editMode === 'full'" @click="edit(row,'full')">📦 入库</el-button>
            <el-button size="small" type="danger" plain @click="delItem(row)">🗑 删除</el-button>
            <el-button size="small" :loading="editingId === row.id && editMode === 'clip'" @click="edit(row,'clip')">🎬 剪辑</el-button>
            <el-button size="small" type="info" plain :loading="eraseId === row.id" @click="openErase(row)">🧹 去字幕</el-button>
            <el-button size="small" :loading="editingId === row.id && editMode === 'rewrite'" @click="edit(row,'rewrite')">✍️ 洗稿</el-button>
            <el-button size="small" type="warning" :loading="analyzingId === row.id" @click="analyze(row)">🎬 拆解</el-button>
            <el-button size="small" type="success" :disabled="row.pq_status === 'publishing'" @click="openUpload(row)">🚀 上传</el-button>
            <el-button v-if="row.replica_report" size="small" link type="primary" @click="showReport(row)">📋报告</el-button>
          </div>
        </div>
      </div>
      <el-empty v-if="!loading && !rows.length" description="暂无已下载视频 —— 去「🎯 对标分解」下载视频，或用「⚡ 快捷发布」上传素材" />
    </el-card>

    <!-- 上传弹窗 -->
    <el-dialog v-model="uploadVisible" title="🚀 上传发布" :width="'min(520px, 94vw)'">
      <template v-if="current">
        <p class="upload-title">📹 {{ current.title || '未命名视频' }}</p>
        <el-form label-width="80px">
          <el-form-item label="平台">
            <el-radio-group v-model="uploadForm.platform">
              <el-radio value="douyin">抖音（全自动）</el-radio>
              <el-radio value="kuaishou" disabled>快手（即将上线）</el-radio>
              <el-radio value="xiaohongshu" disabled>小红书（即将上线）</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="爆款复刻">
            <el-radio-group v-model="uploadForm.dedupe_level">
              <el-radio :value="0">L0 原片直发</el-radio>
              <el-radio :value="1">L1 轻度复刻（推荐）</el-radio>
              <el-radio :value="2">L2 深度复刻</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="发布账号">
            <el-select v-model="uploadForm.account_id" style="width:100%">
              <el-option v-for="a in accounts" :key="a.id" :label="`${a.name || ('账号' + a.id)}${a.is_logged_in ? ' ✅已登录' : ' ⚠️未登录'}`" :value="a.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="定时">
            <el-switch v-model="uploadForm.useSchedule" />
            <el-date-picker v-if="uploadForm.useSchedule" v-model="uploadForm.scheduled_at" type="datetime"
              placeholder="选择发布时间" style="width:100%;margin-top:6px" value-format="YYYY-MM-DDTHH:mm:ss" />
          </el-form-item>
        </el-form>
        <el-alert type="warning" :closable="false" show-icon title="爆款复刻：L0原生直出 / L1轻量焕新(推荐) / L2深度精修 / L3超感重塑（镜像+遮幅+封面重构）" style="margin-bottom:4px" />
      </template>
      <template #footer>
        <el-button @click="uploadVisible = false">取消</el-button>
        <el-button type="success" :loading="uploading" @click="doUpload">🚀 确认上传</el-button>
      </template>
    </el-dialog>

    <!-- 日志弹窗 -->
    <el-dialog v-model="logVisible" title="📜 加工日志" :width="'min(600px, 94vw)'">
      <pre class="log-pre">{{ currentLog }}</pre>
    </el-dialog>

    <!-- 拆解报告弹窗 -->
    <el-dialog v-model="reportVisible" title="🎬 爆款拆解报告" :width="'min(680px, 94vw)'">
      <pre class="log-pre">{{ reportText }}</pre>
    </el-dialog>

    <!-- ▶ 视频预览弹窗（2026-09-03：下载后可打开播放，对比剪辑前后） -->
    <el-dialog v-model="previewVisible" :title="previewTitle" :width="'min(680px, 96vw)'" destroy-on-close>
      <div class="preview-box">
        <video v-if="previewIsVideo && previewUrl" :src="previewUrl" controls autoplay playsinline class="preview-video"></video>
        <el-image v-else-if="previewUrl" :src="previewUrl" fit="contain" class="preview-img" />
        <el-empty v-else description="文件不存在或已被清理" :image-size="80" />
      </div>
      <div class="preview-tip" v-if="previewUrl">提示：可全屏播放；比对剪辑效果请先对同一素材点「🎬 剪辑」再回来预览</div>
    </el-dialog>

    <!-- 🧹 去字幕弹窗（火山引擎 AI MediaKit，2026-09-07 批次 26 Phase 1b） -->
    <el-dialog v-model="eraseDialogVisible" title="🧹 去字幕（火山引擎 AI MediaKit）" :width="'min(560px, 94vw)'" :close-on-click-modal="false" @close="stopErasePoll">
      <div class="erase-box">
        <div class="erase-info" v-if="eraseTarget">
          <div class="erase-title">📹 {{ eraseTarget.title || '未命名视频' }}</div>
          <div class="erase-cost" v-if="eraseEstimate">
            ⏱ 视频时长约 {{ eraseEstimate.seconds }} 秒（{{ (eraseEstimate.seconds/60).toFixed(2) }} 分钟）
          </div>
          <div class="erase-cost">💰 费用估算：<b style="color:#f56c6c;font-size:18px">{{ eraseEstimate.cost }} 元</b>
            <span class="erase-cost-note">{{ eraseForm.pro ? '精细化版（1 元/分钟，V5 AIGC 修复，支持擦水印/台标）' : '标准版（0.4 元/分钟，自动检测画面下方白色字幕）' }}</span>
          </div>
        </div>

        <el-form v-if="!eraseTask" label-width="110px" class="erase-form">
          <el-form-item label="算法版本">
            <el-radio-group v-model="eraseForm.pro" @change="onEraseProChange">
              <el-radio :label="false">标准版（0.4 元/分）</el-radio>
              <el-radio :label="true">精细化版（1 元/分）</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="擦除区域" v-if="eraseForm.pro">
            <el-input v-model="eraseForm.coordinate" placeholder="可选，归一化坐标 x,y,w,h，如 0.5,0.8,1,0.2（左上角x, y, 宽, 高）" />
            <div class="erase-form-tip">留空则自动检测画面下方 50% 白色字幕。填写后擦选区内所有文字。</div>
          </el-form-item>
        </el-form>

        <div v-if="eraseTask" class="erase-task">
          <div class="erase-task-row">
            <span>📊 状态：</span>
            <el-tag :type="eraseTask.status === 'completed' ? 'success' : (eraseTask.status === 'failed' || eraseTask.status === 'timeout') ? 'danger' : 'primary'" size="small">
              {{ eraseStatusText(eraseTask.status) }}
            </el-tag>
            <span class="erase-elapsed" v-if="eraseTask.elapsed">· 已用时 {{ eraseTask.elapsed }}s</span>
          </div>
          <el-progress :percentage="Math.round((eraseTask.progress || 0) * 100)" :stroke-width="14" striped striped-flow class="erase-progress"></el-progress>
          <div class="erase-stage">{{ eraseTask.stage || '处理中…' }}</div>
          <div v-if="eraseTask.error" class="erase-error">⚠️ {{ eraseTask.error }}</div>
          <div v-if="eraseTask.status === 'completed' && eraseTask.result_url" class="erase-success">
            ✅ 字幕擦除完成，已存入素材库（文件名前缀「去字幕_」），可回列表点「🚀 上传」
          </div>
        </div>
      </div>
      <template #footer>
        <el-button @click="eraseDialogVisible = false">关闭</el-button>
        <el-button v-if="!eraseTask" type="primary" :loading="eraseSubmitting" @click="confirmErase">🚀 提交擦除任务</el-button>
        <el-button v-if="eraseTask && (eraseTask.status === 'completed' || eraseTask.status === 'failed' || eraseTask.status === 'timeout')" type="success" @click="onEraseDone">完成，刷新列表</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import api from '../api'

export default {
  name: 'ContentLibrary',
  data() {
    return {
      rows: [],
      loading: false,
      editingId: 0,
      editMode: '',
      accounts: [],
      uploadVisible: false,
      uploading: false,
      current: null,
      uploadForm: { platform: 'douyin', account_id: 0, useSchedule: false, scheduled_at: '', dedupe_level: 1 },
      logVisible: false,
      currentLog: '',
      analyzingId: 0,
      reportVisible: false,
      reportText: '',
      isMobile: window.innerWidth < 768,
      previewVisible: false,
      previewUrl: '',
      previewTitle: '',
      previewIsVideo: true,
      // 字幕擦除（火山引擎 AI MediaKit）
      eraseId: 0,
      eraseDialogVisible: false,
      eraseTarget: null,
      eraseForm: { pro: false, coordinate: '' },
      eraseSubmitting: false,
      eraseTask: null,
      eraseEstimate: null,
      erasePollTimer: null
    }
  },
  mounted() {
    this.load()
    this.loadAccounts()
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    this.stopErasePoll()
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 768
    },
    async onLibUpload(file) {
      // 素材库直接上传：视频/图片/音频 → /assets
      if (!file || !file.raw) return
      const fd = new FormData()
      fd.append('file', file.raw)
      fd.append('account_id', localStorage.getItem('current_account_id') || 0)
      try {
        const r = await api.post('/assets', fd, { timeout: 120000 })
        this.$message.success('素材已上传 ✓')
        this.load()
      } catch (e) {
        this.$message.error('上传失败：' + (e.message || '请重试'))
      }
    },
    async load() {
      this.loading = true
      try {
        const r = await api.get('/content/library')
        this.rows = (r && r.items) || []
      } catch (e) {
        this.$message.error('素材库加载失败: ' + e.message)
      } finally {
        this.loading = false
      }
    },
    async loadAccounts() {
      try {
        const r = await api.get('/accounts')
        this.accounts = (r && (r.accounts || r)) || []
        if (!Array.isArray(this.accounts)) this.accounts = []
      } catch (e) { /* ignore */ }
    },
    fmtSize(n) {
      if (!n) return '-'
      if (n > 1048576) return (n / 1048576).toFixed(1) + 'MB'
      return (n / 1024).toFixed(0) + 'KB'
    },
    async edit(row, mode) {
      this.editingId = row.id
      this.editMode = mode
      try {
        const r = await api.post(`/content/library/${row.id}/edit?itype=${row.type}`, { mode, platform: 'douyin' })
        this.$message.success(r.detail || '已提交加工')
        this.load()
      } catch (e) {
        this.$message.error((e.response && e.response.data && e.response.data.detail) || ('操作失败: ' + e.message))
      } finally {
        this.editingId = 0
        this.editMode = ''
      }
    },
    openUpload(row) {
      this.current = row
      this.uploadForm = { platform: 'douyin', account_id: row.account_id || 0, useSchedule: false, scheduled_at: '', dedupe_level: 1 }
      this.uploadVisible = true
    },
    async doUpload() {
      this.uploading = true
      try {
        const body = { platform: this.uploadForm.platform, account_id: this.uploadForm.account_id, dedupe_level: this.uploadForm.dedupe_level }
        if (this.uploadForm.useSchedule && this.uploadForm.scheduled_at) {
          body.scheduled_at = this.uploadForm.scheduled_at
        }
        const r = await api.post(`/content/library/${this.current.id}/upload?itype=${this.current.type}`, body)
        this.$message.success(r.detail || '已提交发布')
        this.uploadVisible = false
        this.load()
      } catch (e) {
        this.$message.error((e.response && e.response.data && e.response.data.detail) || ('上传失败: ' + e.message))
      } finally {
        this.uploading = false
      }
    },
    showLog(row) {
      this.currentLog = row.auto_log || '（无日志）'
      this.logVisible = true
    },
    async analyze(row) {
      this.analyzingId = row.id
      try {
        const r = await api.post(`/content/library/${row.id}/analyze?itype=${row.type}`, {})
        this.$message.success(r.detail || '拆解已启动')
        // 轮询拆解结果（约 1-3 分钟）
        let tries = 0
        const timer = setInterval(async () => {
          tries++
          try {
            const rr = await api.get('/content/library')
            const item = (rr.items || []).find(i => i.id === row.id && i.type === row.type)
            if (item && item.replica_report) {
              clearInterval(timer)
              this.$message.success('🎬 拆解完成，点击 📋报告 查看')
              this.load()
            } else if (tries >= 20) {
              clearInterval(timer)
              this.$message.info('拆解还在进行，稍后刷新查看（约1-3分钟）')
            }
          } catch (e) { /* ignore */ }
        }, 10000)
      } catch (e) {
        this.$message.error((e.response && e.response.data && e.response.data.detail) || ('拆解失败: ' + e.message))
      } finally {
        this.analyzingId = 0
      }
    },
    showReport(row) {
      try {
        const rep = JSON.parse(row.replica_report)
        this.reportText = JSON.stringify(rep, null, 2)
      } catch (e) {
        this.reportText = row.replica_report
      }
      this.reportVisible = true
    },
    preview(row) {
      // 优先看剪辑后的版本（便于比对），无剪辑看原片
      const url = row.edited_url || row.url || ''
      if (!url) {
        this.$message.warning('本地文件不存在或已被清理，无法预览')
        return
      }
      this.previewUrl = url
      this.previewIsVideo = /\.(mp4|mov|webm|avi|mkv|flv)(\?|$)/i.test(url)
      const tag = row.edited_url ? '（剪辑版）' : '（原片）'
      this.previewTitle = (row.title || '视频素材') + ' ' + tag
      this.previewVisible = true
    },
    async delItem(row) {
      // 删除素材：对标下载 / 本地上传 / AI生成视频；同步删文件与待发布队列项
      const name = (row.title || '该素材').slice(0, 30)
      try {
        await this.$confirm(`确定删除「${name}」？将同时删除视频文件` + (row.pq_status ? '（及其待发布队列项）' : '') + '，不可恢复。', '删除素材', {
          confirmButtonText: '删除', cancelButtonText: '取消', type: 'warning'
        })
      } catch (e) {
        return // 用户取消
      }
      try {
        await api.delete(`/content/library/${row.id}?itype=${row.type}`)
        this.$message.success('已删除')
        this.load()
      } catch (e) {
        this.$message.error((e.response && e.response.data && e.response.data.detail) || e.message)
      }
    },
    // ========== 🧹 去字幕（火山引擎 AI MediaKit，批次 26 Phase 1b） ==========
    async openErase(row) {
      // 打开去字幕弹窗，预检 Key + 估算费用
      if (!row.file_path && !row.url) {
        this.$message.warning('该素材缺少本地文件路径，无法提交去字幕')
        return
      }
      this.eraseId = row.id
      this.eraseTarget = row
      this.eraseForm = { pro: false, coordinate: '' }
      this.eraseTask = null
      this.eraseEstimate = null
      this.eraseDialogVisible = true
      // 异步估算费用（用 file_path 调后端，后端会算视频时长）
      try {
        const r = await api.post('/content/erase-subtitle/estimate', {
          file_path: row.file_path,
          pro: false
        })
        this.eraseEstimate = r
      } catch (e) {
        // 估算失败不阻塞，弹窗仍能提交（后端会再算一次）
        this.eraseEstimate = null
      }
    },
    onEraseProChange() {
      // 切换版本时重新估算费用
      if (!this.eraseTarget) return
      api.post('/content/erase-subtitle/estimate', {
        file_path: this.eraseTarget.file_path,
        pro: this.eraseForm.pro
      }).then(r => { this.eraseEstimate = r }).catch(() => {})
    },
    async confirmErase() {
      // 提交去字幕任务
      if (!this.eraseTarget) return
      this.eraseSubmitting = true
      try {
        const r = await api.post('/content/erase-subtitle', {
          file_path: this.eraseTarget.file_path,
          pro: this.eraseForm.pro,
          coordinate: this.eraseForm.coordinate || ''
        })
        if (!r || !r.task_id) {
          this.$message.error('提交失败：后端未返回 task_id')
          return
        }
        this.$message.success('✅ 任务已提交，正在处理中（约 1-3 分钟）')
        // 启动轮询
        this.startErasePoll(r.task_id)
      } catch (e) {
        const msg = (e.response && e.response.data && e.response.data.detail) || e.message
        this.$message.error('提交失败：' + msg)
      } finally {
        this.eraseSubmitting = false
      }
    },
    startErasePoll(taskId) {
      // 启动 3 秒轮询
      this.stopErasePoll()
      const poll = async () => {
        try {
          const r = await api.get(`/content/erase-subtitle/${taskId}`)
          this.eraseTask = r
          // 计算耗时
          if (r && r.created) {
            r.elapsed = Math.round((Date.now() - r.created) / 1000)
          }
          // 终态：停止轮询
          if (r && (r.status === 'completed' || r.status === 'failed' || r.status === 'timeout' || r.status === 'error')) {
            this.stopErasePoll()
            if (r.status === 'completed') {
              this.$message.success('🧹 字幕擦除完成！已存入素材库')
            }
          }
        } catch (e) {
          this.$message.error('查询任务状态失败：' + e.message)
          this.stopErasePoll()
        }
      }
      poll() // 立即查一次
      this.erasePollTimer = setInterval(poll, 3000)
    },
    stopErasePoll() {
      if (this.erasePollTimer) {
        clearInterval(this.erasePollTimer)
        this.erasePollTimer = null
      }
    },
    eraseStatusText(status) {
      const map = {
        queued: '排队中',
        submitted: '已提交，等待火山处理',
        running: '处理中',
        downloading: '下载结果中',
        completed: '已完成',
        failed: '失败',
        timeout: '超时',
        error: '错误'
      }
      return map[status] || status || '未知'
    },
    onEraseDone() {
      // 完成后关闭弹窗并刷新列表
      this.stopErasePoll()
      this.eraseDialogVisible = false
      this.eraseTask = null
      this.eraseTarget = null
      this.eraseEstimate = null
      this.eraseId = 0
      this.load()
    },
  },
}
</script>

<style scoped>
.card-header { display: flex; justify-content: space-between; align-items: center; }
.no-cover { width: 52px; height: 68px; display: flex; align-items: center; justify-content: center; background: var(--el-fill-color, #f5f7fa); border-radius: 4px; font-size: 20px; }
.log-pre { background: var(--el-fill-color, #f8f9fa); color: var(--el-text-color-regular, #333); padding: 12px; border-radius: 6px; white-space: pre-wrap; max-height: 400px; overflow: auto; font-size: 12px; line-height: 1.6; margin: 0; }
/* 手机端卡片 */
.lib-cards { display: flex; flex-direction: column; gap: 12px; }
.lib-card { border: 1px solid var(--el-border-color-light, #ebeef5); border-radius: 10px; padding: 12px; background: var(--el-bg-color-overlay, #fff); }
.lib-top { display: flex; gap: 10px; }
.lib-cover { width: 88px; height: 118px; border-radius: 6px; flex-shrink: 0; }
.no-cover-big { width: 88px; height: 118px; display: flex; align-items: center; justify-content: center; background: var(--el-fill-color, #f5f7fa); border-radius: 6px; font-size: 28px; flex-shrink: 0; }
.lib-info { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 6px; }
.lib-title { font-size: 14px; font-weight: 600; color: var(--el-text-color-primary, #1f2937); line-height: 1.45; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
.lib-meta { font-size: 12px; color: var(--el-text-color-secondary, #606266); display: flex; align-items: center; gap: 6px; flex-wrap: wrap; }
.lib-status { display: flex; align-items: center; gap: 4px; flex-wrap: wrap; }
.lib-btns { margin-top: 10px; display: flex; flex-wrap: wrap; gap: 6px; border-top: 1px dashed var(--el-border-color-light, #eee); padding-top: 10px; }
.upload-title { color: var(--el-text-color-regular, #666); margin: 0 0 12px; }
.lib-title-cell { cursor: default; }
.row-ops { display: flex; align-items: center; gap: 4px; flex-wrap: wrap; }
.preview-box { background: #000; border-radius: 10px; overflow: hidden; display: flex; align-items: center; justify-content: center; min-height: 220px; }
.preview-video { width: 100%; max-height: 68vh; display: block; }
.preview-img { width: 100%; max-height: 68vh; }
.preview-tip { font-size: 12px; color: var(--el-text-color-secondary, #909399); margin-top: 10px; line-height: 1.6; }
/* 🧹 去字幕弹窗样式 */
.erase-box { display: flex; flex-direction: column; gap: 14px; }
.erase-info { background: var(--el-fill-color, #f5f7fa); padding: 12px 14px; border-radius: 8px; border: 1px solid var(--el-border-color-lighter, #ebeef5); }
.erase-title { font-size: 14px; font-weight: 600; color: var(--el-text-color-primary, #1f2937); margin-bottom: 6px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.erase-cost { font-size: 12px; color: var(--el-text-color-regular, #606266); line-height: 1.6; }
.erase-cost-note { font-size: 11px; color: var(--el-text-color-secondary, #909399); margin-left: 8px; }
.erase-form-tip { font-size: 11px; color: var(--el-text-color-secondary, #909399); margin-top: 4px; line-height: 1.5; }
.erase-task { display: flex; flex-direction: column; gap: 10px; padding: 12px; background: var(--el-fill-color-light, #fafafa); border-radius: 8px; }
.erase-task-row { display: flex; align-items: center; gap: 6px; font-size: 13px; }
.erase-elapsed { font-size: 11px; color: var(--el-text-color-secondary, #909399); }
.erase-progress { margin: 4px 0; }
.erase-stage { font-size: 12px; color: var(--el-text-color-regular, #606266); line-height: 1.5; }
.erase-error { font-size: 12px; color: var(--el-color-danger, #f56c6c); padding: 8px; background: var(--el-color-danger-light-9, #fef0f0); border-radius: 6px; }
.erase-success { font-size: 12px; color: var(--el-color-success, #67c23a); padding: 8px; background: var(--el-color-success-light-9, #f0f9eb); border-radius: 6px; }
@media (max-width: 767px) {
  .card-header { flex-wrap: wrap; gap: 6px; }
  .preview-box { min-height: 160px; }
}
</style>
